var pageIndex = {
  setCondition: function (){
    window.cateData.api.getItemCondition = 'index/all';
  },

  init: function(){
    this.setCondition();
    //设置直播图标
    setLiveIcon();
  }
};

if (document.querySelector('.tab-content')) {
  var touchTabs = new TouchTabs('.tab-content', {
    seledClass: 'seld',
    hookfunction: function (t) {
      // console.log(t);
      if (t === 'online-meetings') {
        window.location.href = solution_host + '/meeting/online-meetings.html';
      } else if (t === 'product') {
        tabDropList.showDropList('dropdown-list-product');
      } else if (t === 'resolve') {
        tabDropList.showDropList('dropdown-list-resolve');
      }else if (t === 'casecatalog') {
        tabDropList.showDropList('dropdown-list-casecatalog');
      }else if (t === 'catalog') {
        window.location.href = solution_m_host + '/' + t + '/';
      } else if (t === 'shop') {
        tabDropList.showDropList('dropdown-list-shop');
      } else {
        window.location.href = solution_host + '/' + t + '/';
      }
    },
  });

}

//touchTabs
function TouchTabs(ele, option){
  //获取元素
  var touchTab = this;

  touchTab.e = document.querySelector(ele);

  //默认设置项
  var defOption = {
    seledClass:'seld', //选中后的css样式
    indicatorClass: '.indicator', //游标的样式
    dateAttribute:'data-page', //获取回传属性
    dataOnlyAction:'data-only-action', //是否只执行方法不添加选中的样式
    isReloc: true, //如果字体点击后会变大，则需要重新计算位置
    hookfunction: function(){},
  };

  touchTab.option = extend(defOption, option);

  touchTab.setindicator = function (target){
    //游标
    touchTab.indicator = document.querySelector(touchTab.option.indicatorClass);

    //设置游标的宽度
    var w = target.clientWidth * 0.4;
    touchTab.indicator.style.width = w + 'px';

    //设置游标的偏移
    // var offsetLeft = $(target).outerWidth() / 2 - touchTab.indicator.clientWidth / 2 + target.offsetLeft;
    var offsetLeft = target.clientWidth / 2 - touchTab.indicator.clientWidth / 2 + target.offsetLeft;
    touchTab.indicator.style.left = offsetLeft + 'px';

    //如果设置了sel时的动画需要重新计算偏移
    if(touchTab.option.isReloc){
      setTimeout(function () {
        var offsetLeft = target.clientWidth / 2 - touchTab.indicator.clientWidth / 2 + target.offsetLeft;
        touchTab.indicator.style.left = offsetLeft + 'px';
      },400);
    }
  };

  touchTab.setEvent = function(event, indexNum){
    if(event){
      indexNum = null;
    }

    //获取所有标签元素
    var itemArr = touchTab.e.querySelectorAll('li');

    if(indexNum){
      // alert(indexNum);
      indexNum = indexNum - 1;
      itemArr.forEach(function(item){
        item.classList.remove(touchTab.option.seledClass);
      });
      itemArr[indexNum].classList.add(touchTab.option.seledClass);
      touchTab.setindicator(itemArr[indexNum]);
    }
    //判断是否选择了正确的元素
    if(!event || !event.target.getAttribute(touchTab.option.dateAttribute)){
      return;
    }

    //判断是否是特殊菜单，不添加选中样式，不移动指示器，只触发相应发放
    if(event.target.getAttribute(touchTab.option.dataOnlyAction)){
      doAction(event.target);
      return;
    }

    itemArr.forEach(function(item){
      item.classList.remove(touchTab.option.seledClass);
    });
    event.target.classList.add(touchTab.option.seledClass);
    touchTab.setindicator(event.target);
    doAction(event.target);
  };

  touchTab.e.addEventListener('click', function(event){
    touchTab.setEvent(event);
  });



  function doAction(target) {
    var attr = target.getAttribute(touchTab.option.dateAttribute);
    if(typeof touchTab.option.hookfunction === 'function'){
      touchTab.option.hookfunction(attr);
    }
  }

  //工具方法
  //简单继承
  function extend(destination,source) {
    if(!source){
      return destination;
    }
    for(var property in source) {
      destination[property] = source[property];
    }
    return destination;
  }

  function init () {
    if(document.querySelector('.seld')){
      var seldOption = document.querySelector('.seld');

      //如过获取不到宽度就 延迟一下继续获取
      if(seldOption.clientWidth === 0){
          setTimeout(function () {
              init();
          }, 200);
          return;
      }else{
          document.querySelector(touchTab.option.indicatorClass).classList.remove('hide');
      }
      if (seldOption) {
          touchTab.setindicator(seldOption);
      }
    }
  }

    init();


  return touchTab.setEvent;
}

